import { makeStyles } from "@material-ui/core/styles";
import pattern from "../../../assets/images/pattern.png";

export const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: "Poppins",
    borderRadius: "8px",
    background: "#FFF",
    marginTop: "20px",
    "& > div:nth-child(n+2)": {
      marginTop: "20px",
    },
  },
  iconBox: {
    display: "flex",
  },
  languageSelector: {
    position: "relative",
    width: "270px",
    [theme.breakpoints.down("xs")]: {
      maxHeight: "237px",
    },
  },
  selectLanguageField: {
    "& .MuiSelect-selectMenu": {
      maxHeight: "360px",
      overflowY: "auto",
      fontFamily: "Poppins",
      fontSize: "14px",
      [theme.breakpoints.down("xs")]: {
        maxHeight: "260px",
      },
    },
  },
  detailHeader: {
    color: "#5B8989",
    fontFmily: "Poppins",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "normal",
    margin: "5px 0px 0px 5px",
  },
  value: {
    color: "#2F4F4F",
    fontFmily: "Poppins",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    marginTop: "5px",
  },
  icon: {
    color: "#FF8547",
  },
  timeZonelabel: {
    color: "#3D3D3D",
    fontFmily: "Poppins",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    margin: "5px 0px 8px 0px",
    display: "inline-block",
  },

  selectTimeContainer: {
    fontFamily: "Poppins",
    width: "100%",
    background: "#FFFFFF",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    marginTop: "20px",
    overflowX: "hidden",
  },
  dayBox: {
    display: "flex",
    border: "1px solid #ECECEC",
    backgroundColor: "white",
    borderRadius: "8px",
    marginTop: "32px",
    width: "100%",
    [theme.breakpoints.up(499)]: {
      width: "fit-content !important",
    },
  },

  carouselContainer: {
    gap: "14px",
    padding: "6px 0",
    margin: "0 12px !important",
  },

  disabledBtn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    backgroundColor: "transparent",
    padding: "10px",
    border: "1px solid transparent",
    color: "#B8B8B8",
    width: "50px",
  },

  activeBtn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    padding: "10px",
    borderRadius: "4px",
    border: "1px solid transparent",
    transition: "0.3s",
    color: "#FFFFFF",
    background: "#FF8547",
    fontWeight: "600",
    width: "50px",
  },

  inactiveBtn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    borderRadius: "4px",
    border: "1px solid transparent",
    transition: "all 0.3s ease",
    color: "#5B8989",
    padding: "10px",
    background: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#FF8547",
      color: "white",
      border: "1px solid #FF8547",
    },
    width: "50px",
  },

  day: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "14px",
    textTransform: "capitalize",
    marginTop: "4px",
    marginBottom: "16px",
  },
  date: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "19px",
    marginTop: "4px",
  },
  displaySlots: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(108px, 1fr))",
    gap: "16px",
    width: "100%",
    padding: "1px",
  },

  time: {
    fontFamily: "Poppins",
    marginBottom: 0,
    fontSize: "14px",
  },
  slotsNumber: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: "400",
    width: "max-content",
    fontSize: "12px",
    lineHeight: "14px",
    margin: "5px 0px 0px 0px",
    color: "#2AC02A",
  },
  noSlots: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: "400",
    width: "max-content",
    fontSize: "12px",
    lineHeight: "14px",
    margin: "5px 0px 0px 0px",
    color: "#F70404",
  },
  noCancellationLeft: {
    display: "flex",
    alignContent: "left",
    alignItems: "left",
    flexDirection: "column",
    fontFamily: "Poppins",
    borderRadius: "8px",
    background: "#FFF",
    marginTop: "10px",
    textAlign: "left",
    [theme.breakpoints.down("xs")]: {
      padding: "0px 10px 10px 0px",
    },
  },
  cancellationText: {
    color: "#EB5E47",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
  },
  requestText: {
    color: "#3D3D3D",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    marginTop: "20px",
  },
  btnContainer: {
    width: "max-content",
    border: "1px solid #25D366",
    color: "#25D366",
    background: "#FFFFFF",
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "21px",
    textAlign: "center",
    marginTop: "20px",
    paddingLeft: "20px",
    paddingRight: "20px",
    textTransform: "none",
    "&:hover": {
      background: "#FFFFFF",
      color: "#25D366",
      border: "1px solid #25D366",
    },
  },

  cancellationOverText: {
    borderRadius: "4px",
    background: "#FEF7F6",
    color: "#EB5E47",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "normal",
    padding: "10px 5px",
    marginTop: "15px",
  },
  cancelClassBtn: {
    minWidth: "142px",
    maxWidth: "max-content",
    border: "1px solid #FF712D",
    color: "#FF712D",
    background: "#FFFFFF",
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "21px",
    textAlign: "center",
    marginTop: "20px",
    paddingLeft: "20px",
    paddingRight: "20px",
    textTransform: "none",
    "&:hover": {
      background: "#FFFFFF",
      color: "#FF712D",
      border: "1px solid #FF712D",
    },
  },
  balanceCancellation: {
    fontFamily: "Poppins",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
  },
  cancellationLft: {
    color: "#666",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
  },
  banner: {
    marginTop: "40px",
    display: "flex",
    width: "100%",
    padding: "16px 32px",
    justifyContent: "space-around",
    borderRadius: "8px",
    border: "1px solid #FFE2D6",
    background: "linear-gradient(92deg, #F79845 0%, #F7A445 100%)",
    boxShadow: "0px 2px 8px 0px rgba(134, 57, 29, 0.20)",
    [theme.breakpoints.down("xs")]: {
      background: `url(${pattern})`,
      backgroundSize: "100% 100%",
      backgroundRepeat: "no-repeat",
    },
  },
  insideBanner: {
    display: "flex",
    flexDirection: "column",
    alignContent: "center",
    alignItems: "center",
  },
  bannerText1: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "normal",
  },

  mobileBannerContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  bannerButton: {
    padding: "6px 12px",
    justifyContent: "center",
    alignItems: "center",
    gap: "4px",
    borderRadius: "4px",
    border: "none",
    background: "#FFF",
    borderColor: "#FFFFFF",
  },
  bannerImage: {
    width: "100%",
    height: "100%",
    flexShrink: 0,
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },

  noticeText: {
    color: "#666",
    fontWeight: "500",
    fontSize: "14px",
    backgroundColor: "#F5F5F5",
    padding: "12px 28px",
    textAlign: "center",
    borderRadius: "4px ",
    width: "100%",
    marginTop: "40px",
    [theme.breakpoints.down(500)]: {
      padding: "12px",
    },
  },

  substituteText: {
    display: "flex",
    justifyContent: "space-between",
    gap: "16px",
    alignItems: "center",
    color: "#666",
    fontSize: "14px",
    fontWeight: "600",
    borderBottom: "1px solid #ECECEC",
    paddingBottom: "4px",
    marginTop: "32px",
    cursor: "pointer",
    marginBottom: "85px",
  },

  dateSlotCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
  },

  slotButton: {
    padding: "10px 22px",
    fontSize: "14px",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  occupied: {
    background: "#D8C8C0",
    border: "1px solid #D8C8C0",
    color: "white",
    cursor: "not-allowed",
  },
  available: {
    background: "#FFFFFF",
    border: "1px solid #31AF6D",
    color: "#31AF6D",
    "&:hover": {
      backgroundColor: "#31AF6D",
      color: "white",
    },
  },
  availableSelected: {
    background: "#31AF6D",
    color: "white",
  },
  onRequest: {
    background: "#FFFFFF",
    border: "1px solid #F5A300",
    color: "#F5A300",
    "&:hover": {
      backgroundColor: "#F5A300",
      color: "white",
    },
  },
  onRequestSelected: {
    background: "#F5A300",
    color: "white",
  },

  slotInfo: {
    borderBottom: "1px solid #ECECEC",
    paddingBottom: "8px",
    width: "fit-content",
    display: "flex",
    gap: "24px",
    marginBottom: "24px",
    "&>p": {
      marginBottom: "0",
      color: "#666",
      fontSize: "12px",
    },

    "&>p>span": {
      display: "inline-block",
      width: "12px",
      height: "12px",
      borderRadius: "1px",
      marginRight: "4px",
    },
  },
  container: {
    display: "flex",
    gap: "12px",
    margin: "32px 0",
  },
  card: {
    flex: "1 1 100%",
    padding: "10px 16px",
    border: "1px solid #ddd",
    borderRadius: 12,
    textAlign: "center",
    cursor: "pointer",
    maxWidth: "120px",
    transition: "0.3s",
    "&:hover": {
      backgroundColor: "#FF8547",
      "& div": {
        color: "#fff !important",
      },
    },
  },

  svgIcon: {
    width: "20px",
    height: "20px",
    marginBottom: 4,
  },
  title: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#666",
  },
  subtitle: {
    fontSize: "10px",
    color: "#666",
  },
  selected: {
    backgroundColor: "#FF8547",
    border: "1px solid #FF8547",
    "& div": {
      color: "#fff !important",
    },
  },

  nextSevenDaysStyles: {
    marginTop: "16px",
    overflowX: "auto",
    "-webkit-overflow-scrolling": "touch",
    scrollbarWidth: "thin",
    scrollbarColor: "#DADADA #F5F5F5",
    "&::-webkit-scrollbar": {
      height: "6px",
      width: "6px",
      display: "block",
    },
    "&::-webkit-scrollbar-track": {
      background: "#F5F5F5",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#DADADA",
      borderRadius: "4px",
      visibility: "visible",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#BEBEBE",
    },
    [theme.breakpoints.down("sm")]: {
      "&::-webkit-scrollbar": {
        display: "block",
      },
      "&::-webkit-scrollbar-thumb": {
        visibility: "visible",
      },
    },
  },
}));
